const BUYER_SESSION_STORAGE_KEY = 'b2b-buyer-session-token'

export const BUYER_SESSION_TOKEN_RESET_EVENT = 'storefront-buyer-session-token-reset'
export const BUYER_SESSION_EXPIRED_EVENT = 'storefront-buyer-session-expired'

let buyerSessionTokenState: string | null = null

const readBuyerSessionTokenStorage = () => {
  if (typeof window === 'undefined') return null

  try {
    const raw = window.localStorage.getItem(BUYER_SESSION_STORAGE_KEY)
    const normalized = String(raw ?? '').trim()
    return normalized || null
  } catch {
    return null
  }
}

export const getBuyerSessionToken = () => {
  if (buyerSessionTokenState) return buyerSessionTokenState
  buyerSessionTokenState = readBuyerSessionTokenStorage()
  return buyerSessionTokenState
}

export const setBuyerSessionToken = (token: string | null | undefined) => {
  const normalized = String(token ?? '').trim()
  buyerSessionTokenState = normalized || null
  if (typeof window === 'undefined') return buyerSessionTokenState

  try {
    if (buyerSessionTokenState) {
      window.localStorage.setItem(BUYER_SESSION_STORAGE_KEY, buyerSessionTokenState)
    } else {
      window.localStorage.removeItem(BUYER_SESSION_STORAGE_KEY)
    }
  } catch {
    // Ignore localStorage write errors.
  }

  return buyerSessionTokenState
}
